var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-not common-bg"},[_c('community-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }